import { HttpClient } from './http';
export const qiniu = {
    qiniuToken: '',

    imgCDN: '',

    async fetchQiniuToken() {
        if (this.qiniuToken) {
            return this.qiniuToken;
        }
        let json = await HttpClient.get('/qiniu/token');
        this.qiniuToken = json.token;
        this.imgCDN = json.cdn;
        return this.qiniuToken;
    },
};
